import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type DiagnosisCodeInputFields = {
  diagnosisCode: string;
};

const DiagnosisCodeInput = ({
  diagnosisCodeFieldConfig,
}: {
  diagnosisCodeFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<DiagnosisCodeInputFields>();

  return (
    <InputField
      type="text"
      {...register("diagnosisCode", {
        required: {
          value:
            diagnosisCodeFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange diagnoskod`,
        },
      })}
      label={t`Diagnoskod`}
      showOptionalLabel={
        diagnosisCodeFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.diagnosisCode?.message}
    />
  );
};

export default DiagnosisCodeInput;
